import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import {
  DelaAcceptAllButton,
  DelaRejectAllButton
} from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(1.5)
  },
  delaRecommendationButtonsContainer: {
    display: 'flex',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap'
  }
}));

const useDelaButtonStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(1.3),
      padding: theme.spacing(0.3, 1)
    }
  }
}));

const title = (
  <FormattedMessage id="resourceCertificatesAndLicensesCard.title" />
);

const CertificatesCardTitle = ({
  editable,
  acceptAllCertificateNudges,
  rejectAllCertificateNudges,
  canEditSkills
}) => {
  const classes = useStyles();
  const delaButtonClasses = useDelaButtonStyles();

  const showActions =
    editable &&
    canEditSkills &&
    (acceptAllCertificateNudges || rejectAllCertificateNudges);

  if (!showActions) {
    return title;
  }

  return (
    <div className={classes.titleContainer}>
      {title}
      <div className={classes.delaRecommendationButtonsContainer}>
        <DelaAcceptAllButton
          classes={delaButtonClasses}
          onClick={acceptAllCertificateNudges}
          dataQeId="AcceptAllCertificateNudges"
        >
          <FormattedMessage id="dela.acceptAll" />
        </DelaAcceptAllButton>
        <DelaRejectAllButton
          classes={delaButtonClasses}
          onClick={rejectAllCertificateNudges}
          dataQeId="RejectAllCertificateNudges"
        >
          <FormattedMessage id="dela.rejectAll" />
        </DelaRejectAllButton>
      </div>
    </div>
  );
};

CertificatesCardTitle.propTypes = {
  editable: PropTypes.bool.isRequired,
  acceptAllCertificateNudges: PropTypes.func,
  rejectAllCertificateNudges: PropTypes.func,
  canEditSkills: PropTypes.bool
};

export default CertificatesCardTitle;
